import { createFileRoute } from '@tanstack/react-router';
import {
  ClientBoard,
  ClientBoardPageHeader,
} from '@/features/clients/components/ClientBoard';

export const Route = createFileRoute('/_authenticated/clients/board')({
  component: ClientsBoardPage,
});

function ClientsBoardPage() {
  return (
    <div className="space-y-6">
      <ClientBoardPageHeader />
      <ClientBoard />
    </div>
  );
}
